<template>
  <el-dialog width="600px" title="订单发货" v-model="isvisible">
    <el-descriptions :column="2">
      <el-descriptions-item label="收货人姓名">{{
        receiverInfo.receiver
      }}</el-descriptions-item>
      <el-descriptions-item label="收货人电话">{{
        receiverInfo.receiverphone
      }}</el-descriptions-item>
      <el-descriptions-item label="收货地址">{{
        receiverInfo.receiveraddress
      }}</el-descriptions-item>
    </el-descriptions>
    <el-divider />
    <el-form
      ref="deliverGoodsFormRef"
      :model="deliverGoodsForm"
      :rules="rules"
      label-width="120px"
    >
      <el-form-item label="快递单号" prop="expressnum">
        <el-input
          v-model.trim="deliverGoodsForm.expressnum"
          placeholder="请输入快递单号"
        />
      </el-form-item>
      <el-form-item label="快递公司" prop="expresscompany">
        <el-input
          v-model.trim="deliverGoodsForm.expresscompany"
          placeholder="请输入快递公司"
        />
      </el-form-item>
      <el-form-item label="运费金额" prop="freightamount">
        <el-input
          v-model.number="deliverGoodsForm.freightamount"
          placeholder="请输入运费金额"
        />
      </el-form-item>
      <el-form-item label="后端处理备注" prop="deliverynote">
        <el-input
          type="textarea"
          autosize
          v-model.trim="deliverGoodsForm.deliverynote"
          placeholder="请输入后端处理备注"
        />
      </el-form-item>
    </el-form>

    <template #footer>
      <span class="dialog-footer">
        <el-button @click="closeDialog">关闭</el-button>
        <el-button type="danger" @click="doDeliverGoods" :loading="loading" >{{
          loading ? "提交中 ..." : "确认"
        }}</el-button>
      </span>
    </template>
  </el-dialog>
</template>
  <script setup>
import { ref, defineExpose, defineEmits } from "vue";
import { ElMessage } from "element-plus";
import { saveOrderAddress } from "@/api/order/address";

let timer;

const loading = ref(false);

const emit = defineEmits(["click"]); // 声明父触发事件

const isvisible = ref(false);
const changeVisible = (v) => {
  isvisible.value = v;
};

const deliverGoodsFormRef = ref();
const deliverGoodsForm = ref({
  orderid: "",
  goodsid:"",
  expressnum: "",
  expresscompany: "",
  freightamount: "",
  deliverynote: "",
});

const receiverInfo = ref({
  receiver: "",
  receiverphone: "",
  receiveraddress: "",
});
const receiverMethod = (receiverObj) => {
  receiverInfo.value = {
    receiver: receiverObj.receiver,
    receiverphone: receiverObj.receiverphone,
    receiveraddress: receiverObj.receiveraddress,
    
  };
  deliverGoodsForm.value  = {
    orderid: receiverObj.orderid,
    goodsid: receiverObj.goodsid,
    expressnum: receiverObj.expressnum,
    expresscompany: receiverObj.expresscompany,
    freightamount: receiverObj.freightamount,
    deliverynote: receiverObj.deliverynote,
  };
};

defineExpose({ changeVisible, receiverMethod });

// const toEmits = () => {
//   //触发父组件中暴露的click方法并携带数据
//   isvisible.value = false;
//   console.log("isvisible--", isvisible.value);
//   emit("click", doDeliverGoods);
// };

const doDeliverGoods = () => {
  deliverGoodsFormRef.value.validate((valid) => {
    if (!valid) {
      //ElMessage("请先完善表单数据填写！");
      return;
    }

    //deliverGoodsForm.value.orderid = receiverInfo.value.orderid;
    saveOrderAddress(deliverGoodsForm.value).then((res) => {
      loading.value = true;
      timer = setTimeout(() => {
        // 动画关闭需要一定的时间
        setTimeout(() => {
          loading.value = false;
        }, 400);
        if (res.data.code === 1) {
          closeDialog();
          emit("click");
        } else {
          ElMessage.error(res.data.msg);
        }
      }, 1000);
    });
  });
};

const closeDialog = () => {
  isvisible.value = false;
  deliverGoodsFormRef.value.resetFields();
  clearTimeout(timer);
};
//表单验证规则
const rules = ref({
  expressnum: [
    {
      required: true,
      message: "请输入快递单号",
      trigger: "blur",
    },
    {
      min: 2,
      max: 60,
      message: "快递单号长度2到60",
      trigger: "blur",
    },
  ],
  expresscompany: [
    {
      required: true,
      message: "请输入快递公司",
      trigger: "blur",
    },
    {
      min: 2,
      max: 50,
      message: "快递公司长度2到50",
      trigger: "blur",
    },
  ],
  freightamount: [
    {
      type: "number",
      message: "运费必须是数字",
      trigger: "blur",
    },
  ],
  deliverynote: [
    {
      min: 2,
      max: 200,
      message: "后端处理备注长度2到200",
      trigger: "blur",
    },
  ],
});
</script>
  <style scoped>
.el-dialog {
  text-align: left;
}
.el-dialog__body {
  padding-top: 15px;
}
</style>